import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useBreakpointValue,
  useColorModeValue,
} from '@chakra-ui/react';
import { useSidebarDrawer } from '../../hooks/sidebarDrawer';

import { SidebarNav } from './SidebarNav';

export function Sidebar() {
  const { isOpen, onClose } = useSidebarDrawer();

  const isDrawerSidebar = useBreakpointValue({
    base: true,
    lg: false,
  });

  const bg = useColorModeValue('white', 'gray.800');
  const color = useColorModeValue('gray.700', 'white');

  if (isDrawerSidebar) {
    return (
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay>
          <DrawerContent bg={bg} py="4">
            <DrawerCloseButton color={color} mt="6" />
            <DrawerHeader color={color}>Navegação</DrawerHeader>

            <DrawerBody>
              <SidebarNav />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    );
  }

  return (
    <Box as="aside" w="80" bg={bg} borderRightWidth="1px">
      <SidebarNav />
    </Box>
  );
}
